import { memo, useState } from 'react';

import { Button, Flex } from 'antd';

import { SettingFilled } from '@ant-design/icons';
import classnames from 'classnames';

import { TABLE_CONFIG_KEYS } from '../../../constants/table-configurations';

import AppTableSettings from '../../../components/AppTable/AppTableSettings';
import { TABLE_SIZE } from '../../../components/AppTable/constants';
import AppSearch from '../../../components/Search/Search';

import AppDropdown from '../../ui-components/AppDropdown';

function TableControls({
  actions = [],
  data,
  isCollapsedMode = false,
  tableColumnPreferences,
  tableConfigKey = TABLE_CONFIG_KEYS.TASKS,
  handleSearchQuery,
  resetSettings,
  selectColumn
}) {
  const [isSettingsOpen, setSettings] = useState(false);

  function toggleSettings() {
    setSettings(prevState => !prevState);
  }

  return (
    <div className={classnames({ 'p-2': isCollapsedMode })} style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
      <Flex align="center" gap="small" justify="end" vertical={false}>
        <AppSearch
          id="search"
          placeholder={tableConfigKey === TABLE_CONFIG_KEYS.TASKS ? 'Search Tasks' : 'Search Events'}
          handleChange={handleSearchQuery}
        />

        <Flex gap="small" justify="end" align="center">
          <AppDropdown label="Actions" items={actions} />

          <Button color="primary" size="large" variant="solid" icon={<SettingFilled />} onClick={toggleSettings}>
            Settings
          </Button>
        </Flex>
      </Flex>
      {isSettingsOpen && (
        <AppTableSettings
          className="mt-2"
          columns={data[tableColumnPreferences?.id]?.preparedColumns}
          size={TABLE_SIZE.SM}
          tableId={tableColumnPreferences?.id}
          choseVisibleColumns={selectColumn}
          handleResetSettings={resetSettings}
        />
      )}
    </div>
  );
}

export default memo(TableControls);
